import Ripple from 'vuetify/lib/directives/ripple';

var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(_setup.ShareBtn, {
    directives: [{ def: Ripple, name: "ripple", rawName: "v-ripple" }],
    class: _setup.isMobile ? "rounded-15" : "rounded-20",
    attrs: {
      "url-name": "lpu",
      type: "lpu",
      size: _setup.isMobile ? 36 : 52,
      url: _setup.reverseFullL10N({
        name: "lpu",
        args: {
          language: _setup.urlLang,
          town_translit: _vm.lpu.town.translit,
          lpu_translit: _vm.lpu.translit,
        },
      }),
    },
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }